import React from 'react';
export function RedirectIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M2 2h7v2H4v16h16v-5h2v7H2V2z"
  }), React.createElement("path", {
    d: "M20 5.414V11h2V2h-9v2h5.586l-9.293 9.293 1.414 1.414L20 5.414z"
  }));
}